/*
 * An AngularJS Localization Service
 *
 * Written by Jim Lavin
 * http://codingsmackdown.tv
 *
 * http://codingsmackdown.tv/blog/2012/12/14/localizing-your-angularjs-app/
 */
angular.module('localization', ['ngSanitize'])
    // localization service responsible for retrieving resource files from the server and
    // managing the translation dictionary
    .factory('localize', ['$http', '$rootScope', '$window', '$filter', '$enhancedHttp',
    function ($http, $rootScope, $window, $filter, $enhancedHttp) {
        var localize = {
            // use the $window service to get the language of the user's browser
            language: '',
            // array to hold the localized resource string entries
            dictionary: [],
            // location of the resource file
            url: undefined,
            // flag to indicate if the service hs loaded the resource file
            resourceFileLoaded: false,
            // success handler for all server communication
            successCallback: function (data) {
                // store the returned array in the dictionary
                localize.dictionary = data;
                // set the flag that the resource are loaded
                localize.resourceFileLoaded = true;
                // broadcast that the file has been loaded
                $rootScope.$broadcast('localizeResourcesUpdated');
            },
            // allows setting of language on the fly
            setLanguage: function (value) {
                localize.language = value;
                localize.initLocalizedResources();
            },
            // allows setting of resource url on the fly
            setUrl: function (value) {
                localize.url = value;
                localize.initLocalizedResources();
            },
            // builds the url for locating the resource file
            buildUrl: function () {
                if (!localize.language) {
                    var lang, androidLang;
                    // works for earlier version of Android (2.3.x)
                    if ($window.navigator && $window.navigator.userAgent && (androidLang = $window.navigator.userAgent.match(/android.*\W(\w\w)-(\w\w)\W/i))) {
                        lang = androidLang[1];
                    }
                    else {
                        // works for iOS, Android 4.x and other devices
                        lang = $window.navigator.userLanguage || $window.navigator.language;
                    }
                    // set language
                    localize.language = lang.toLowerCase();
                }
                return 'assets/i18n/resources-locale_' + localize.language.toLowerCase() + '.js';
            },
            // loads the language resource file from the server
            initLocalizedResources: function () {
                // build the url to retrieve the localized resource file
                var url = localize.url || localize.buildUrl();
                var self = this;
                // request the resource file
                // TODO: Remove this when we start really translating to other language
                // HACK: To avoid maintaining multiple files that needs to be the same we just use default
                url = 'assets/i18n/resources-locale_default.js';
                var request = function (url) {
                    $enhancedHttp({
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                        url: url,
                        disableErrorDialog: true,
                        cache: false
                    }, self.loadingIndicator)
                        .then(localize.successCallback, function (error) {
                        // the request failed set the url to the default resource file
                        console.log('resources', error);
                        var defaultUrl = 'assets/i18n/resources-locale_default.js';
                        if (url === defaultUrl) {
                            return;
                        }
                        request(defaultUrl);
                        // request the default resource file
                        // $http({ method:"GET", url:url, cache:false }).success(localize.successCallback);
                    });
                };
                request(url);
                // $http({ method:"GET", url:url, cache:false }).success(localize.successCallback).error(function () {
                //     // the request failed set the url to the default resource file
                //     var url = '/i18n/resources-locale_default.js';
                //     // request the default resource file
                //     $http({ method:"GET", url:url, cache:false }).success(localize.successCallback);
                // });
            },
            // checks the dictionary for a localized resource string
            getLocalizedString: function (value) {
                // default the result to an empty string
                var result = '';
                // make sure the dictionary has valid data
                try {
                    if ((localize.dictionary !== []) && (localize.dictionary.length > 0)) {
                        // use the filter service to only return those entries which match the value
                        // and only take the first result
                        var entry = $filter('filter')(localize.dictionary, function (element) {
                            return element.key === value;
                        })[0];
                        // set the result
                        result = entry.value;
                    }
                }
                catch (e) {
                    console.log("i18 getLocalizedString() ERROR", localize);
                }
                // return the value to the call
                return result;
            }
        };
        // force the load of the resource file
        localize.initLocalizedResources();
        // return the local instance when called
        return localize;
    }])
    // simple translation filter
    // usage {{ TOKEN | VALUE 1| VALUE2 | i18n }}
    .filter('i18n', ['localize', '$filter', function (localize, $filter) {
        return function (input) {
            //            return localize.getLocalizedString(input);
            var values = input.split('|');
            if (values.length != undefined)
                if (values.length >= 1) {
                    // construct the tag to insert into the element
                    var tag = localize.getLocalizedString(values[0]);
                    // update the element only if data was returned
                    if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                        if (values.length > 1 && values[1] !== '') {
                            var offset = 1;
                            // If values are given as array and only as VALUE1 then use this array in stead
                            // NOTE: This is not used since putting an array as VALUE1 in the template will convert to string of comma seperated values
                            if (values[1] instanceof Array) {
                                values = values[1];
                                offset = 0;
                            }
                            for (var index = offset; index < values.length; index++) {
                                // Reformat dates from yyyy-MM-dd to local format
                                var isoDatePatterm = new RegExp("^([0-9]{4})-([0-9]{2})-([0-9]{2})$");
                                if (isoDatePatterm.exec(values[index])) {
                                    // TODO: Get format based on browser's locale
                                    values[index] = $filter('date')(values[index], 'MM/dd/yyyy');
                                }
                                var target = '{' + (index - offset) + '}';
                                tag = tag.replace(target, values[index]);
                            }
                        }
                        // insert the text into the element
                        return tag;
                    }
                    ;
                }
            return '';
        };
    }])
    // translation directive that can handle dynamic strings
    // updates the text value of the attached element
    // usage <span data-i18n="TOKEN" ></span>
    // or
    // <span data-i18n="TOKEN|VALUE1|VALUE2" ></span>
    .directive('i18n', ['localize', function (localize) {
        var i18nDirective = {
            restrict: "EAC",
            updateText: function (elm, token) {
                var values = token.split('|');
                if (values.length >= 1) {
                    // construct the tag to insert into the element
                    var tag = localize.getLocalizedString(values[0]);
                    // update the element only if data was returned
                    if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                        if (values.length > 1) {
                            for (var index = 1; index < values.length; index++) {
                                var target = '{' + (index - 1) + '}';
                                tag = tag.replace(target, values[index]);
                            }
                        }
                        // insert the text into the element
                        elm.text(tag);
                    }
                    ;
                }
            },
            link: function (scope, elm, attrs) {
                scope.$on('localizeResourcesUpdated', function () {
                    i18nDirective.updateText(elm, attrs.i18n);
                });
                attrs.$observe('i18n', function (value) {
                    i18nDirective.updateText(elm, attrs.i18n);
                });
            }
        };
        return i18nDirective;
    }])
    // translation directive that can handle dynamic strings
    // updates the attribute value of the attached element
    // usage <span data-i18n-attr="TOKEN|ATTRIBUTE" ></span>
    // or
    // <span data-i18n-attr="TOKEN|ATTRIBUTE|VALUE1|VALUE2" ></span>
    .directive('i18nAttr', ['localize', function (localize) {
        var i18NAttrDirective = {
            restrict: "EAC",
            updateText: function (elm, token) {
                var values = token.split('|');
                // construct the tag to insert into the element
                var tag = localize.getLocalizedString(values[0]);
                // update the element only if data was returned
                if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                    if (values.length > 2) {
                        for (var index = 2; index < values.length; index++) {
                            var target = '{' + (index - 2) + '}';
                            tag = tag.replace(target, values[index]);
                        }
                    }
                    // insert the text into the element
                    elm.attr(values[1], tag);
                }
            },
            link: function (scope, elm, attrs) {
                scope.$on('localizeResourcesUpdated', function () {
                    i18NAttrDirective.updateText(elm, attrs.i18nAttr);
                });
                attrs.$observe('i18nAttr', function (value) {
                    i18NAttrDirective.updateText(elm, value);
                });
            }
        };
        return i18NAttrDirective;
    }]);
//# sourceMappingURL=i18n.module.js.map